import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import LoginRoutingPath from 'src/app/login/login-routing-path';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { CognitoUtil } from 'src/app/shared/utils/cognito.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private cognitoUtil: CognitoUtil,
    private stateManagementService: StateManagementService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    const user = this.stateManagementService.getUser();
    const cognitoUser = this.cognitoUtil.getCurrentUser();
    if (cognitoUser && user?.isLoggedIn) return true;
    else if (cognitoUser) this.cognitoUtil.getCurrentUser()!.signOut();
    else this.stateManagementService.logout();
    this.router.navigate([LoginRoutingPath.loginForm]);
    return false;
  }
}
